module.exports = __webpack_public_path__ + "static/engineering4-zig-zag-b45529b112ca68db1015bdbf34f3daab.png";